import type { MessageTemplateType } from "./messageTemplateTypes";

export type CoverageStaff = {
  id: string;
  name: string;
  email?: string | null;
};

export type CoverageSectionOffice = {
  mainAddress?: {
    city?: string | null;
    state?: string | null;
  } | null;
};

export type CoverageSection = {
  id: string;
  name: string;
  recruiter?: CoverageStaff | null;
  playerEngagementConsultant?: CoverageStaff | null;
  sectionOffice?: CoverageSectionOffice | null;
};

export type CoverageRoleKind = "recruiter" | "playerEngagement";

export const COVERAGE_GROUP_BY_PARAM = "groupBy";
export const UNASSIGNED_COVERAGE_GROUP_ID = "unassigned";

export type CoverageGroupBy = "consultant" | "section";

export type SectionConsultantAssignmentRole = "CAREER_CONSULTANT" | "DIRECTOR";

export const SECTION_CONSULTANT_ROLE_LABELS: Record<SectionConsultantAssignmentRole, string> = {
  CAREER_CONSULTANT: "Career Consultant",
  DIRECTOR: "Director"
};

export function sectionConsultantRoleLabel(roleType: SectionConsultantAssignmentRole): string {
  return SECTION_CONSULTANT_ROLE_LABELS[roleType];
}

export type CoverageGroupMember = {
  id: string;
  sectionId: string;
  sectionName: string;
  person: CoverageStaff | null;
  roleType?: SectionConsultantAssignmentRole;
  assignmentId?: string;
  location?: string | null;
};

export type CoverageGroupRow = {
  id: string;
  label: string;
  location?: string | null;
  isUnassigned: boolean;
  canAdd: boolean;
  members: CoverageGroupMember[];
  lockedSectionId?: string;
  lockedSectionName?: string;
  lockedPerson?: CoverageStaff | null;
};

export type SectionOption = {
  id: string;
  name: string;
};

export type CareerConsultantAssignment = {
  id: string;
  isActive: boolean;
  roleType: SectionConsultantAssignmentRole;
  section: {
    id: string;
    name: string;
  };
  consultant: CoverageStaff;
};

export type { MessageTemplateType };

/** @deprecated Use MessageTemplate */
export type BirthdayGreetingTemplateType = MessageTemplateType;

export type MessageTemplate = {
  id: string;
  templateType: MessageTemplateType;
  subject: string | null;
  body: string | null;
  signature: string | null;
  updatedAt: string;
};

/** @deprecated Use MessageTemplate */
export type BirthdayGreetingTemplate = MessageTemplate;
